<template>
  <div ref="chartContainer" class="chart-container" :style="{ width: width, height: height }"></div>
</template>

<script>
import * as echarts from 'echarts'
import { onResize } from '@/utils/responsive'

export default {
  name: 'Chart',
  props: {
    option: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      chart: null,
      resizeHandler: null
    }
  },
  watch: {
    option: {
      handler(newOption) {
        if (this.chart && newOption) {
          this.chart.setOption(newOption, true)
        }
      },
      deep: true
    }
  },
  mounted() {
    this.initChart()
    this.resizeHandler = onResize(() => {
      if (this.chart) {
        this.chart.resize()
      }
    })
  },
  beforeDestroy() {
    if (this.resizeHandler) {
      this.resizeHandler()
    }
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chartContainer) return
      
      this.chart = echarts.init(this.$refs.chartContainer, this.theme)
      
      if (this.option) {
        this.chart.setOption(this.option)
      }
    },
    resize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  min-height: 200px;
}
</style>

